import { WindowMullionType } from "building-types/settings/settingsTypesEnum";

export const rectangleMullionTypes: {
  [key in WindowMullionType]?: boolean;
} = {
  [WindowMullionType.ORTHOGONAL]: true,
  [WindowMullionType.ORTHOGONAL_CUSTOM]: true,
  [WindowMullionType.DISABLED]: true,
};
